module.exports = __webpack_public_path__ + "media/Images/icon-mobile-phone-pig-86b446605ecc5d8ebeacd7dca5948f08.svg";